
import api from "@/services/api"
import { Grid } from "gridjs-react"
import { useEffect, useState } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import Swal from "sweetalert2"
import { historySavingColumns } from "./columns"
import { formatRupiah } from "@/helpers/utils"

const MandatorySavingDetail = () => {
    const { id } = useParams()
    const [detail, setDetail] = useState({})
    const [historySaving, setHistorySaving] = useState([])
    const [effectiveAmount,setEffectiveAmount] = useState(0)
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate(-1)

    useEffect(() => {
        if (id) {
            fetchMemberDetail(id)
            fetchHistorySaving(id)
        }
    }, [id])

    const fetchHistorySaving = async (memberId) => {
        setLoading(true)
        try {
            const response = await api.get(`/members/${memberId}/savings/transactions/history?type=mandatory`)
            setHistorySaving(response?.data)
            const totalAmount = (response?.data || []).reduce((sum, val) => sum + (Number(val.amount) || 0), 0)
            setEffectiveAmount(totalAmount)
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                icon: 'error',
                text: 'Error fetch detail history savings'
            })
        }
        setLoading(false)
    }

    const fetchMemberDetail = async () => {
        try {
          setLoading(true);
          const response = await api.get(`/members/${id}`);
          setDetail(response.data);
        } catch (error) {
          console.error('Error fetching member detail:', error);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Failed to load member details'
          });
        } finally {
          setLoading(false);
        }
    };

    return (
        <>
            <nav className="flex mb-6" aria-label="Breadcrumb">
                <ol className="inline-flex items-center space-x-1 md:space-x-3">
                    <li className="inline-flex items-center">
                        <Link
                            to="/dashboard"
                            className="inline-flex items-center text-sm font-medium text-gray-700 hover:text-blue-600"
                        >
                            <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"></path>
                            </svg>
                            Dashboard
                        </Link>
                    </li>
                    <li>
                        <div className="flex items-center">
                            <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path>
                            </svg>
                            <Link
                                to="/admin/list-mandatory-savings/"
                                className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2"
                            >
                                List Simpanan Wajib
                            </Link>
                        </div>
                    </li>
                    <li>
                        <div className="flex items-center">
                            <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd"></path>
                            </svg>
                            <span
                                className="ml-1 text-sm font-medium text-gray-700 hover:text-blue-600 md:ml-2"
                            >
                                Detail
                            </span>
                        </div>
                    </li>
                </ol>
            </nav>
            {loading && (
                <div className="flex items-center justify-center min-h-screen">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                    <span className="ml-2 text-gray-600">Loading savings details...</span>
                </div>
            )}
            {!loading && (
                <div class="bg-white rounded-lg border min-h-screen">
                    <div className="p-6">
                        <div class="flex justify-between items-center mb-6">
                            <h1 class="text-2xl font-bold">Detail Simpanan Wajib Anggota</h1>
                            <button onClick={() => navigate(-1)} class="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded">
                                Kembali Ke Halaman Sebelumnya
                            </button>
                        </div>

                        <div className="bg-white border rounded-lg shadow p-6">
                            <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                                <div className="col-span-1 md:col-span-1">
                                    <div className="space-y-3">
                                        <div className="flex items-start">
                                            <span className="text-gray-600 w-1/5 min-w-[120px]">Nama Pemilik Rekening</span>
                                            <span className="mx-2">:</span>
                                            <span className="font-semibold flex-1">{detail?.full_name || '-'}</span>
                                        </div>
                                        <div className="flex items-start">
                                            <span className="text-gray-600 w-1/5 min-w-[120px]">Alamat</span>
                                            <span className="mx-2">:</span>
                                            <span className="font-semibold flex-1">{detail?.address || '-'}</span>
                                        </div>
                                        <div className="flex items-start">
                                            <span className="text-gray-600 w-1/5 min-w-[120px]">Nomor Telepon</span>
                                            <span className="mx-2">:</span>
                                            <span className="font-semibold flex-1">{detail?.phone_number || '-'}</span>
                                        </div>
                                        <div className="flex items-start">
                                            <span className="text-gray-600 w-1/5 min-w-[120px]">Saldo Efektif</span>
                                            <span className="mx-2">:</span>
                                            <span className="font-semibold flex-1">{ formatRupiah(effectiveAmount) }</span>
                                        </div>
                                    </div>
                                    <hr className="my-3" />
                                    <Grid
                                        data={historySaving}
                                        columns={historySavingColumns}
                                        pagination={true}
                                        search={true}
                                        sort={true}
                                        style={{
                                            td: {
                                                'text-align': 'left',
                                            },
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}

export default MandatorySavingDetail